import { useEffect, useState } from "react";
import "../blocks/updateToast/updateToast.css";

// Listens for the "swUpdateAvailable" event (dispatched from index.jsx when
// the service worker finishes installing a new version in the background)
// and shows a small prompt to refresh, instead of leaving the person stuck
// on a stale cached version until they happen to fully close the app.
const UpdateToast = () => {
  const [waitingRegistration, setWaitingRegistration] = useState(null);
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    const handleUpdate = (event) => {
      setWaitingRegistration(event.detail);
    };
    window.addEventListener("swUpdateAvailable", handleUpdate);
    return () => window.removeEventListener("swUpdateAvailable", handleUpdate);
  }, []);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const handleControllerChange = () => {
      // The new service worker has taken over — safe to reload now.
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      handleControllerChange
    );
    return () =>
      navigator.serviceWorker.removeEventListener(
        "controllerchange",
        handleControllerChange
      );
  }, []);

  if (!waitingRegistration) {
    return null;
  }

  const handleRefresh = () => {
    setIsReloading(true);
    const waitingWorker = waitingRegistration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
    } else {
      // Fallback in case the reference to the waiting worker is gone.
      window.location.reload();
    }
  };

  return (
    <div className="updateToast">
      <span className="updateToast__text">
        A new version of WTWR is available.
      </span>
      <button
        type="button"
        className="updateToast__button"
        onClick={handleRefresh}
        disabled={isReloading}
      >
        {isReloading ? "Updating…" : "Refresh"}
      </button>
    </div>
  );
};

export default UpdateToast;
